import styled from "styled-components";

export const StyledLink = styled.p`
     border-radius:50%;
     width:100%;
     /* height:30px; */
     /* line-height:30px; */
     display: flex;
     align-items: center;
     justify-content: flex-start;
     text-decoration: none;
     margin: 8px 0px;
`;
export const StyledBox = styled.div` 
  display: flex;
  align-items: center;
  padding: 0px;
  border-radius: 5px;
  transition: all 0.5s ease, background-color 0.5s ease;
  cursor: pointer;
padding: 4px;
  &:hover {
    transform: scale(1.1);
    background-color: #F1C114;
    padding: 4px;
  }

  svg {
    transition: all 0.5s ease;
     color: #fff;
     fill:#fff;
     width:1.5rem;
     height:1.5rem;
  }

  &:hover svg {
    transform: rotate(-20deg) scale(1.2);
  }
`;